import React from "react";
import { Container } from "@mui/material";
import { styled } from "@mui/system";
import { motion } from "framer-motion";

const StyledBackground = styled(motion.div)({
  minHeight: "100vh",
  background: "url(https://images.unsplash.com/photo-1499750310107-5fef28a66643)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "relative",
  overflow: "hidden"
});

const MyStudyDeskBackground: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <StyledBackground>
      <Container>
        {children}
      </Container>
    </StyledBackground>
  );
};


export default MyStudyDeskBackground;